import { render, staticRenderFns } from "./area-trigger.vue?vue&type=template&id=1a9054f9&"
import script from "./area-trigger.vue?vue&type=script&lang=ts&"
export * from "./area-trigger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports